import { useEffect, useState, useRef } from 'react';
import './Statistics.css';
import { StatisticsDetail } from './statisticsDetails/StatisticsDetail';

export const Statistics = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const currentSection = sectionRef.current;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.3 }
    );

    if (currentSection) {
      observer.observe(currentSection);
    }

    return () => {
      if (currentSection) {
        observer.unobserve(currentSection);
      }
    };
  }, []);

  return (
    <div className='fourth-container' ref={sectionRef} style={{
      backgroundImage: 'url(../assets/jobs.jpg)'
    }}>
      {/* Dark overlay with our theme */}
      <div className="fourth-overlay"></div>

      {/* Gold accent pattern */}
      <div className="fourth-pattern"></div>

      {/* Content container */}
      <div className="fourth-content">
        <StatisticsDetail
          icon="pi-check"
          counter="9"
          title="WORKS COMPLETED"
          startCounting={isVisible}
        />
        <StatisticsDetail
          icon="pi-book"
          counter="3"
          title="YEARS OF EXPERIENCE"
          startCounting={isVisible}
        />
        <StatisticsDetail
          icon="pi-users"
          counter="8"
          title="TOTAL CLIENTS"
          startCounting={isVisible}
        />
      </div>
    </div>
  );
};